var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTooltip = function SvgTooltip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#C4C4C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.289 17.334H9.117v-2.172h2.172zM11.76 12.32c-.038.05-.075.111-.112.173-.025.05-.062.1-.087.15-.037.061-.062.123-.087.185-.025.05-.05.1-.062.162a2.6 2.6 0 0 0-.124.781H9.104c0-.446.05-.819.136-1.154h.025v-.074c.633-2.184 2.929-2.308 3.078-4.021.087-1.055-.658-2.073-1.688-2.296-1.13-.248-2.16.41-2.52 1.39-.136.41-.496.72-.942.72h-.199a.99.99 0 0 1-.943-1.303 4.34 4.34 0 0 1 4.828-2.979c1.886.286 3.375 1.899 3.623 3.785.335 2.47-1.762 3.115-2.742 4.48",
    clipRule: "evenodd"
  })));
};
export default SvgTooltip;